import React from "react";
import PropTypes from "prop-types";

const BasicInfoStep = ({ formData, errors, onInputChange }) => {
  return (
    <div className="widget-form-section">
      <div className="widget-form-field">
        <label htmlFor="name">
          Widget Name <span className="required">*</span>
        </label>
        <input
          id="name"
          type="text"
          value={formData.name}
          onChange={(e) => onInputChange("name", e.target.value)}
          placeholder="e.g., support-widget"
          className={errors.name ? "error" : ""}
        />
        {errors.name && (
          <span className="widget-form-error">{errors.name}</span>
        )}
        <small>Internal identifier (lowercase, hyphens allowed)</small>
      </div>

      <div className="widget-form-field">
        <label htmlFor="display_name">
          Display Name <span className="required">*</span>
        </label>
        <input
          id="display_name"
          type="text"
          value={formData.display_name}
          onChange={(e) => onInputChange("display_name", e.target.value)}
          placeholder="e.g., Support Assistant"
          className={errors.display_name ? "error" : ""}
        />
        {errors.display_name && (
          <span className="widget-form-error">{errors.display_name}</span>
        )}
        <small>Friendly name shown to users</small>
      </div>

      <div className="widget-form-field">
        <label htmlFor="status">Status</label>
        <select
          id="status"
          value={formData.status}
          onChange={(e) => onInputChange("status", e.target.value)}
        >
          <option value="active">Active</option>
          <option value="paused">Paused</option>
          <option value="inactive">Inactive</option>
        </select>
        <small>Active widgets can receive messages</small>
      </div>
    </div>
  );
};

BasicInfoStep.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
    display_name: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default BasicInfoStep;
